import axios from "axios";
import AppContext from '@/js/common/AppContext';
import Util from '@/js/common/Util';
import { getTokenCrtDt, removeTokenCrtDt, setTokenCrtDt } from "../layout/TokenCheck";

interface chkInfoProps {
    alertCode: "0" | "1" | "2" | "3"
    alertMsg?: string
}
interface AxiosProps {
    url: string
    methodType: "get" | "post"
    paramType?: "object" | "json"
    paramData?: object
    isMultipart?: boolean
    responseType?: "json" | "blob" | "text"
    onSuccessFn?: Function
    onFailedFn?: Function
    skipFailedAlert?: boolean
    signal?: AbortSignal
    disableDownloadOnBlob?: boolean
}
const Axios = {
    dataAccess: (_opt: AxiosProps) => {
        const chkInfo: chkInfoProps = Axios.chkAccessPsb(_opt.url);
        if (chkInfo.alertCode !== "0") {
            if (chkInfo.alertCode === "2") {
                AppContext.openAlert({
                    title: "알림",
                    msg: chkInfo.alertMsg,
                    icon: "check",
                    handleClose: () => {
                        window.location.href = "/";
                    }
                });
                return;
            }
            AppContext.openAlert({
                title: "알림",
                msg: chkInfo.alertMsg,
                icon: "check"
            });
            Axios.hideAllSpinner();
            return;
        }
        if (Util.isEmpty(_opt.url)) {
            AppContext.openAlert({
                title: "알림",
                msg: "요청 주소 정보가 없습니다.",
                icon: "check"
            });
            Axios.hideAllSpinner();
            return;
        }
        if (Util.isEmpty(_opt.methodType)) {
            AppContext.openAlert({
                title: "알림",
                msg: "요청 타입 정보가 없습니다.",
                icon: "check"
            });
            Axios.hideAllSpinner();
            return;
        }
        const callServer = () => {
            const paramData = Util.nvl(_opt.paramData, {});
            if (_opt.methodType === "get") {
                axios.get(
                    `${AppContext.backendUrl}/${_opt.url}`,
                    {
                        headers: {
                            'Authorization': localStorage.getItem("grantType") + ' ' + localStorage.getItem("accessToken")
                        },
                        responseType: _opt.responseType ? _opt.responseType : 'json',
                        params: paramData,
                        signal: _opt.signal
                    }
                ).then((res) => {
                    Axios.successFunc(_opt, res);
                }).catch((error) => {
                    Axios.catchHandler(error, _opt);
                });
            } else if (_opt.methodType === "post") {
                if (_opt.isMultipart) { // 멀티파트인 경우
                    const formData = new FormData(); // 폼 데이터 준비
                    for (const key in paramData) {
                        if (Array.isArray(paramData[key])) { // 배열이면
                            paramData[key].forEach((item: any) => {
                                formData.append(key, item); // 반복문을 활용하여 파일들을 formData 객체에 추가한다
                            });
                        } else {
                            if (Util.isEmpty(paramData[key])) {
                                formData.append(key, "");
                            } else {
                                formData.append(key, paramData[key]);
                            }
                        }
                    }
                    axios.post(
                        `${AppContext.backendUrl}/${_opt.url}`,
                        formData,
                        {
                            headers: {
                                'Authorization': localStorage.getItem("grantType") + ' ' + localStorage.getItem("accessToken"),
                                'Content-type': 'multipart/form-data'
                            },
                            transformRequest: (data, headers) => {
                                return data;
                            },
                            signal: _opt.signal
                        }
                    ).then((res) => {
                        Axios.successFunc(_opt, res);
                    }).catch(error => {
                        Axios.catchHandler(error, _opt);
                    });
                } else {
                    let contentType = "";
                    if (_opt.paramType === "object") {
                        contentType = "application/x-www-form-urlencoded";
                    } else if (_opt.paramType === "json") {
                        contentType = "application/json";
                    } else {
                        contentType = "application/x-www-form-urlencoded";
                    }
                    axios.post(
                        `${AppContext.backendUrl}/${_opt.url}`,
                        paramData,
                        {
                            headers: {
                                'Authorization': localStorage.getItem("grantType") + ' ' + localStorage.getItem("accessToken"),
                                'Content-type': contentType
                            },
                            signal: _opt.signal
                        }
                    ).then((res) => {
                        Axios.successFunc(_opt, res);
                    }).catch(error => {
                        Axios.catchHandler(error, _opt);
                    });
                }
            }
        }
        if (_opt.url === undefined) {
            alert("url 정보가 없습니다.");
            return;
        }
        const grantType = _opt.url.split("/")[0];
        const tokenCrtDt = getTokenCrtDt();
        if (["portal", "common"].indexOf(grantType) !== -1) {
            callServer();
        } else if (["system", "admin", "api", "gs-gate"].indexOf(grantType) !== -1) {
            if (tokenCrtDt === null) {
                AppContext.openAlert({
                    title: "인증정보 없음",
                    msg: "인증 정보가 없습니다.",
                    icon: "error",
                    handleClose: () => {
                        window.location.href = "/";
                    }
                });
                return;
            }
            const nowDtStr = Util.getSpecificDate("-", "day", 0, "SS", "");
            if (nowDtStr === undefined) {
                alert("시간정보 로딩 도중 오류가 발생하였습니다.");
                return;
            }
            const nowDt = new Date(nowDtStr);
            const calTime = (+nowDt) - (+new Date(tokenCrtDt));
            const accessTokenRemainTime = (AppContext.accessTokenExpireTime * 60000) - calTime;
            const refreshTokenRemainTime = (AppContext.refreshTokenExpireTime * 60000) - calTime;
            if (refreshTokenRemainTime < 60000) {
                Axios.removeAuthInfo();
                window.location.href = "/";
                return;
            }
            if (accessTokenRemainTime < (AppContext.accessTokenExpireTime * 6000)) {
                Axios.tokenReIssuance(_opt);
                return;
            }
            callServer();
        } else {
            AppContext.openAlert({
                title: "권한 오류",
                msg: "권한 타입 정보가 없습니다.",
                icon: "check"
            });
            return;
        }
    },
    successFunc: (_opt: AxiosProps, res: any) => {
        if (_opt.responseType === "blob") {
            const dispos = res.headers["content-disposition"];
            if (Util.isEmpty(dispos)) {
                AppContext.openAlert({
                    title: "파일 없음",
                    msg: "파일이 존재하지 않습니다.",
                    icon: "error"
                });
                Axios.hideAllSpinner();
                return;
            }

            const contentType = res.headers['content-type'] || 'application/octet-stream';
            const blob = new Blob([res.data], { type: contentType });
            const blobUrl = window.URL.createObjectURL(blob);
            const name = dispos.split("fileName=")[1].replace(/"/g, "");
            const decodedName = decodeURI(name);

            // 파일 다운로드
            if (_opt.disableDownloadOnBlob !== true) {
                const link = document.createElement('a');
                link.href = blobUrl;
                link.setAttribute('download', decodedName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }

            Axios.hideAllSpinner();
            if (_opt.onSuccessFn && typeof _opt.onSuccessFn === 'function') {
                _opt.onSuccessFn.call(this, { blobUrl, fileName: decodedName });
            }
            return;
        }
        const resData = res.data;
        const resultCode = resData._resultCode_;
        if (resultCode === "success") {
            if (_opt.onSuccessFn && typeof _opt.onSuccessFn === 'function') {
                _opt.onSuccessFn.call(this, resData);
            }
        } else if (resultCode === "invalid") {
            if (_opt.onFailedFn) {
                _opt.onFailedFn.call(this, resData);
            }
        } else if (resultCode === "failed") {
            Axios.hideAllSpinner();
            if (_opt.onFailedFn) {
                _opt.onFailedFn.call(this, resData);
            }
            if (_opt.skipFailedAlert !== true) {
                AppContext.openAlert({
                    title: resData._ttl_ ? resData._ttl_ : "시스템 알림",
                    msg: resData._msg_,
                    icon: "error"
                });
            }
        }
    },
    failedFunc: (_opt: AxiosProps, error: any) => {
        if (_opt.onFailedFn) {
            _opt.onFailedFn.call(this, error);
        }
    },
    catchHandler: (error: any, _opt: AxiosProps) => {
        // eslint-disable-next-line
        console.log(error);
        const errInfo = error.toJSON();
        if (errInfo.name === "CanceledError") {
            Axios.hideAllSpinner();
            Axios.failedFunc(_opt, error);
            return;
        }
        if (Util.isEmpty(errInfo.status) || errInfo.status === 404) { // 개발/운영서버 환경은 NGINX, 서버 내려가있으면 404를 리턴하므로 OR조건 추가, 해당조건이 없으면 인증토큰이 유실되는 현상 발생
            AppContext.openAlert({
                title: "http 접근 오류",
                msg: "http 통신 오류입니다.",
                icon: "error"
            });
            Axios.hideAllSpinner();
            return;
        }
        if (errInfo.status === 401) { // 401 발생 시 토큰 만료
            Axios.removeAuthInfo();
            AppContext.openAlert({
                title: "인증정보 만료",
                msg: "인증정보가 만료되어 접근이 불가합니다.",
                icon: "error",
                handleClose: () => {
                    window.location.href = "/";
                }
            });
            Axios.hideAllSpinner();
            return;
        } else if (errInfo.status === 403) { // 403 발생 시 권한 불충분
            AppContext.openAlert({
                title: "접근권한 없음",
                msg: "권한이 불충분하여 접근이 불가합니다.",
                icon: "error",
                handleClose: () => {
                    Axios.removeAuthInfo();
                    window.location.href = "/";
                }
            });
            Axios.hideAllSpinner();
            return;
        } else {
            Axios.hideAllSpinner();
            Axios.failedFunc(_opt, error);
        }
    },
    // 토큰 재발급
    tokenReIssuance: (_opt?: AxiosProps) => {
        const accessToken = localStorage.getItem("accessToken");
        const refreshToken = localStorage.getItem("refreshToken");
        axios.post(
            `${AppContext.backendUrl}/portal/auth/reissue.do`,
            {
                "accessToken": accessToken,
                "refreshToken": refreshToken
            }
        ).then((res) => {
            const resData = res.data;
            Axios.removeAuthInfo();
            if (resData._resultCode_ === "success") { // 발급 성공 시
                setTokenCrtDt();
                localStorage.setItem("grantType", resData.item.grantType);
                localStorage.setItem("accessToken", resData.item.accessToken);
                localStorage.setItem("refreshToken", resData.item.refreshToken);
                if (_opt) { // 요청 정보가 존재하면
                    Axios.dataAccess(_opt); // 최초 호출정보 재호출
                }
            } else { // 토큰 만료
                window.location.href = "/";
            }
        }).catch(error => {
            AppContext.openAlert({
                title: "인증정보 발급 실패",
                msg: "인증정보 재발급에 실패하였습니다.",
                icon: "error",
                handleClose: () => {
                    Axios.tokenReIssuance(_opt);
                }
            });
            Axios.hideAllSpinner();
        });
    },
    // 접근 가능한 url 여부 체크
    chkAccessPsb: (url: string | undefined): chkInfoProps => {
        if (url === undefined) {
            return {
                alertCode: "1",
                alertMsg: "호출주소 정보가 없습니다."
            }
        }
        const tokenCrtDt = getTokenCrtDt();
        if (url.startsWith("system", 0)) { // 사용자 인증 후 접근 가능
            if (Util.isEmpty(tokenCrtDt)) {
                removeTokenCrtDt();
                return {
                    alertCode: "2",
                    alertMsg: "로그인 후 이용 가능합니다."
                }
            }
        } else if (url.startsWith("admin", 0)) { // 관리자 인증 후 접근 가능
            if (Util.isEmpty(tokenCrtDt)) {
                removeTokenCrtDt();
                return {
                    alertCode: "2",
                    alertMsg: "로그인 후 이용 가능합니다."
                }
            }
            if (localStorage.getItem('isAdmin') !== "1") {
                return {
                    alertCode: "3",
                    alertMsg: "관리자만 이용 가능합니다."
                }
            }
        }
        return {
            alertCode: "0"
        };
    },
    removeAuthInfo: () => {
        removeTokenCrtDt();
        localStorage.removeItem('grantType');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
    },
    hideAllSpinner: () => {
        AppContext.hideSpinner();
    }
};
export default Axios;